const button = document.getElementById('ScrollToTopBtn');

function scrollToTop() {
  function scrollFunction() {
    if (
      document.body.scrollTop > 20
      || document.documentElement.scrollTop > 20
    ) {
      button.style.display = 'block';
    } else {
      button.style.display = 'none';
    }
  }

  window.onscroll = function windowOnscroll() {
    scrollFunction();
  };

  button.addEventListener('click', () => {
    window.scrollTo(0, 0);
  });
}

export default scrollToTop;
